<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="11"
    viewBox="0 0 31 11"
    fill="none"
  >
    <g clip-path="url(#clip0_4482_116573)">
      <path
        d="M16.0153 3.68506C15.9982 5.07247 17.2179 5.84675 18.1368 6.30706C19.0809 6.7794 19.398 7.08226 19.3944 7.5046C19.3872 8.15106 18.6413 8.43633 17.9431 8.44744C16.7252 8.46689 16.0171 8.10939 15.4541 7.83894L15.0153 9.94969C15.5802 10.2174 16.6261 10.4507 17.7107 10.4609C20.2565 10.4609 21.9221 9.16893 21.9311 7.16562C21.9411 4.62328 18.5106 4.4825 18.5341 3.34609C18.5422 3.00155 18.862 2.63386 19.5628 2.54032C19.9096 2.49308 20.8672 2.45696 21.9528 2.97099L22.3789 0.928777C21.7951 0.7102 21.0447 0.500885 20.1105 0.500885C17.7143 0.500885 16.0288 1.81049 16.0153 3.68506ZM26.4732 0.676858C26.0084 0.676858 25.6165 0.955636 25.4417 1.38353L21.805 10.3109H24.349L24.8553 8.87255H27.9641L28.2578 10.3109H30.5L28.5434 0.676858H26.4732ZM26.8291 3.2794L27.5632 6.89703H25.5525L26.8291 3.2794ZM12.9308 0.676858L10.9255 10.3109H13.3497L15.3541 0.676858H12.9308ZM9.34451 0.676858L6.82124 7.23415L5.80058 1.6586C5.68077 1.03621 5.20783 0.676858 4.68263 0.676858H0.557654L0.5 0.956561C1.3468 1.1455 2.3089 1.45021 2.89175 1.77622C3.24848 1.97535 3.35028 2.14947 3.46739 2.62275L5.40061 10.3109H7.96262L11.8903 0.676858H9.34451Z"
        fill="url(#paint0_linear_4482_116573)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4482_116573"
        x1="3531.32"
        y1="27.0457"
        x2="3611.5"
        y2="-870.162"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#222357" />
        <stop offset="1" stop-color="#254AA5" />
      </linearGradient>
      <clipPath id="clip0_4482_116573">
        <rect
          width="30"
          height="10"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
